// Environment configuration

const isDev = import.meta.env.DEV;
const devHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';

// Proxied dev stacks (orc + Traefik) serve web, API and realtime from one
// origin and set VITE_API_URL=/api, VITE_REALTIME_URL=/. See orc/README.md.
const proxiedApiUrl = import.meta.env.VITE_API_URL as string | undefined;
const proxiedRealtimeUrl = import.meta.env.VITE_REALTIME_URL as string | undefined;

export const API_BASE_URL = !isDev
  ? 'https://guac.fancyhands.com'
  : proxiedApiUrl
    ? new URL(proxiedApiUrl, origin).href.replace(/\/$/, '')
    : `http://${devHost}:4242`;

export const REALTIME_URL = !isDev
  ? 'wss://realtime-tuna.fancyhands.com'
  : proxiedRealtimeUrl
    ? new URL(proxiedRealtimeUrl, origin).origin
    : `ws://${devHost}:3001`;

export const TOKEN_STORAGE_KEY = 'fh_access_token';
